import { useState } from 'react';
import { Link, useNavigate } from '@tanstack/react-router';
import { Button } from '../components/Button';
import { useAuthStore } from '../lib/auth';
import { AuthShell, TextField } from './Join';

export function LoginRoute() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [adminPassphrase, setAdminPassphrase] = useState('');
  const [needsOwnerPassphrase, setNeedsOwnerPassphrase] = useState(false);
  const login = useAuthStore((s) => s.login);
  const loading = useAuthStore((s) => s.loading);
  const error = useAuthStore((s) => s.error);
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const result = await login(
      needsOwnerPassphrase ? { username, password, adminPassphrase } : { username, password },
    );
    if (result === 'admin_passphrase_required') {
      setNeedsOwnerPassphrase(true);
      return;
    }
    if (result === 'ok') navigate({ to: '/' });
  }

  return (
    <AuthShell title="Log in" blurb="Use your site username and password.">
      <form onSubmit={submit} className="space-y-4">
        <TextField label="Username" value={username} onChange={setUsername} autoComplete="username" />
        <TextField
          label="Password"
          value={password}
          onChange={setPassword}
          type="password"
          autoComplete="current-password"
        />
        {needsOwnerPassphrase && (
          <TextField
            label="Owner passphrase"
            value={adminPassphrase}
            onChange={setAdminPassphrase}
            type="password"
            autoComplete="off"
          />
        )}
        {error && <div className="text-sm text-danger">{error}</div>}
        <Button type="submit" size="lg" className="w-full" disabled={loading}>
          Log in
        </Button>
        <p className="text-center text-sm text-ink-muted">
          New here?{' '}
          <Link to="/join" className="text-accent hover:underline">
            Join now
          </Link>
        </p>
      </form>
    </AuthShell>
  );
}
